import React from 'react'

import { useAnalysisType } from 'redux/hooks/AnalysisTypes'
import { useParams } from 'utils/hooks'

import AnalysisTypeSettingsOrganism from 'components_new/organisms/analysis_types/AnalysisTypeSettings'

import AnalysisTypeTemplate from 'components_new/templates/AnalysisTypeTemplate'

const AnalysisTypeSettings = () => {
  const { id } = useParams<{ id: string }>()

  const { analysisType } = useAnalysisType(id)

  if (!analysisType) return <></>

  return (
    <AnalysisTypeTemplate variant="static">
      <AnalysisTypeSettingsOrganism analysisType={analysisType} />
    </AnalysisTypeTemplate>
  )
}

export default AnalysisTypeSettings
